import React, { FC } from "react";
import favicon from "../../img/finwhite.png"; // adjust path to where favicon.png lives
import "./FinllieLogo.css";
// Full logo (wordmark) — import the full finllie.png
import wordmarkSrc from "../../img/finwhite.png"; // adjust path if needed

interface FinllieLogoProps {
  /** px size of the water-drop icon only */
  size?: number;
  /** whether to run the blink/pulse animation */
  animate?: boolean;
  /** show full wordmark logo instead of just the icon */
  wordmark?: boolean;
  /** px width for wordmark variant */
  wordmarkWidth?: number;
}



const FinllieLogo: FC<FinllieLogoProps> = ({
  size = 48,
  animate = true,
  wordmark = false,
  wordmarkWidth = 160,
}) => {
  if (wordmark) {
    return (
      <img
        src={wordmarkSrc}
        alt="Finllie"
        className={`fnl-wordmark ${animate ? "fnl-animate" : ""}`}
        style={{ width: wordmarkWidth, height: "auto" }}
        draggable={false}
      />
    );
  }

  return (
    <img
      src={favicon}
      alt="Finllie"
      className={`fnl-icon ${animate ? "fnl-animate" : ""}`}
      style={{ width: size, height: size, objectFit: "contain" }}
      draggable={false}
    />
  );
};

export default FinllieLogo;